export default "__VITE_ASSET__BHtVvm$Y__"